import {
  Dashboard as DashboardIcon,
  DashboardCustomize,
  ErrorOutline,
  KeyboardArrowDown,

  SettingsInputComponent,
  ArrowRight,
  KeyboardArrowRight,
  Logout,
  Menu as MenuIcon
} from "@mui/icons-material";
import { Box, CircularProgress, Menu, MenuItem, Radio, Select } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import CallDetails from "./dashboard/CallDetails";
import CallRoute from "./dashboard/CallRoute";
import CallRoutings from "./dashboard/CallRoutings";
import Channels from "./dashboard/Channels";
import Dailer from "./dashboard/Dailer";
import Home from "./dashboard/Home";
import Recordings from "./dashboard/Recordings";
import Settings from "./dashboard/Settings";
import Sidebar from "./layout/Sidebar";
import { checkIfUserHasRelatedOrg } from "./utils/checkUserOrgStatus";
import ChangeOrgModal from "./modals/ChangeOrgModal";
import posthog from "posthog-js";
import Front from "@frontapp/plugin-sdk";
import FrontPluginDefault from "./dashboard/FrontPluginDefault";

const Dashboard = () => {

  let latestContext;


  const navigate = useNavigate()




  //front logic

  const [conversation, setConversation] = useState()
  const [lastEntryPoint, setLastEntryPoint] = useState(null)

useEffect(()=>{

  let subscribe =  Front.contextUpdates.subscribe((context) => {
    latestContext = context
    console.log('[Front Context Update] Full context:', context);
    console.log('[Front Context Update] EntryPoint:', context.entryPoint);
    console.log('[Front Context Update] Conversation ID:', context.conversation.id);
    
    latestContext.listMessages().then((response)=> {
      console.log('[Front Context] listMessages response:', response)
      let link;
      if(response.results.length > 0){
        const latestMessageIndex = response.results.length -1;
        let body = response.results[latestMessageIndex].content.body
        console.log('[Front Context] latest message body:', body)
        const path = body.match(/twilanswer\.com(\/[^"]+)/)?.[1];
        console.log('[Front Context] extracted path:', path);
        link = path;
      }
      
      const currentConversationId = latestContext.conversation.id;
      const lastConversationId = localStorage.getItem('last_conversation_id');
      const currentEntryPoint = latestContext.entryPoint?.type;
      const entryPointChanged = currentEntryPoint !== lastEntryPoint;
      const conversationChanged = currentConversationId !== lastConversationId;
      
      console.log('[Front Context] Debug values:');
      console.log('  - currentConversationId:', currentConversationId);
      console.log('  - lastConversationId:', lastConversationId);
      console.log('  - currentEntryPoint:', currentEntryPoint);
      console.log('  - lastEntryPoint:', lastEntryPoint);
      console.log('  - entryPointChanged:', entryPointChanged);
      console.log('  - conversationChanged:', conversationChanged);
      console.log('  - link:', link);
      
      setConversation(currentConversationId)
      
      // Option D: Conversation-First with EntryPoint Override
      
      // 1. Conversation ID changes (highest priority) - always navigate appropriately
      if (conversationChanged) {
        console.log('[Front Context] Conversation changed, navigating based on context')
        localStorage.setItem('last_conversation_id', currentConversationId)
        
        if (link) {
          console.log('[Front Context] Navigating to extracted link:', link)
          navigate(link)
        } else if (currentEntryPoint === "CONTACT_HANDLE") {
          console.log('[Front Context] CONTACT_HANDLE with new conversation, navigating to /dashboard/dialer')
          localStorage.setItem('last_contact_handle_conversation_id', currentConversationId)
          navigate('/dashboard/dialer')
        } else {
          console.log('[Front Context] No link found, navigating to /dashboard/front')
          navigate('/dashboard/front')
        }
        setLastEntryPoint(currentEntryPoint)
        return;
      }
      
      // 2. Same conversation + EntryPoint changes (medium priority) - allow EntryPoint to override
      if (!conversationChanged && entryPointChanged) {
        console.log('[Front Context] Same conversation but EntryPoint changed, allowing override')
        
        if (currentEntryPoint === "CONTACT_HANDLE") {
          console.log('[Front Context] EntryPoint changed to CONTACT_HANDLE, navigating to /dashboard/dialer')
          localStorage.setItem('last_contact_handle_conversation_id', currentConversationId)
          navigate('/dashboard/dialer')
        } else if (link) {
          console.log('[Front Context] EntryPoint changed and link exists, navigating to:', link)
          navigate(link)
        } else {
          console.log('[Front Context] EntryPoint changed but no link, navigating to /dashboard/front')
          navigate('/dashboard/front')
        }
        setLastEntryPoint(currentEntryPoint)
        return;
      }
      
      // 3. Same conversation + same EntryPoint (lowest priority) - no navigation
      if (!conversationChanged && !entryPointChanged) {
        console.log('[Front Context] No changes detected, no navigation needed')
        return;
      }
    }).catch((error) => {
      console.error('[Front Context] Error in listMessages:', error);
    })
    
    //console.log('[Front Context] latestContext:', latestContext);
  });

  return()=>{
    subscribe.unsubscribe()
  }

},[])



  const [openChangeOrg, setOpenChangeOrg] = useState(false)


  const location = useLocation()
  let checks = async () => {
    return await checkIfUserHasRelatedOrg(); // Return the resolved value
  };

  const getOrg = async () => {
    let org = await axios.post(
      process.env.REACT_APP_BACKEND_URL + "get-organization",
      { orgId: JSON.parse(localStorage.getItem('organization')).orgId.S }
    );

    localStorage.setItem('organization', JSON.stringify(org.data.organization))
    //console.log('kkdkdk')
  }
  useEffect(() => {
    // Handle the resolved value with `then`
    checks().then((res) => {
      //console.log(res); // This will log the actual result (true or false)
      if (!res) {
        setOpenChangeOrg(true)
      } else {
        getOrg()
      }
    });
    checkIfUserHasRelatedOrg()
  }, [location.pathname])




  const [openSidebar, setOpenSidebar] = useState(false);
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')))

  const [orgs, setOrgs] = useState()
  const getAllOrgs = async () => {
    let orgs = await axios.post(
      process.env.REACT_APP_BACKEND_URL + "get-organizations", {
      userId: JSON.parse(localStorage.getItem('user')).userId.S
    }
    );
    //console.log('orgs', orgs)
    setOrgs(orgs.data)
  }

  useEffect(() => {
    getAllOrgs()
  }, []);




  //check if user has twilio_information and exist 



  const [err_msg, setErrorMsg] = useState(null);
  const [loader, setLoader] = useState(false);
  const changeOrganization = async (org_id) => {
    try {
      let org = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "get-organization",
        { orgId: org_id }
      );
      localStorage.setItem(
        "organization",
        JSON.stringify(org.data.organization)
      );

      window.location.reload()
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        console.error("Response data:", error.response.data);
        setErrorMsg(error.response.data.message);
      }
      setLoader(false);
    }
  };

  const [loadState, setLoadState] = useState(true)


  useEffect(() => {
    let organization = JSON.parse(localStorage.getItem("organization"));
    if (!organization) {
      window.location.pathname = '/login';
    } else if (!organization.twilio_integration) {
      window.location.pathname = '/register';
    } else {

      let user_data = JSON.parse(localStorage.getItem('user'))



      let data = {
        email:user.email.S,
        name :user.fName.S+' '+user.lName.S,
        org_id: organization.orgId.S,
        org_name: organization.organization_name.S,
      }
      console.log('data',data)
      console.log('user_id',user.userId.S)
      posthog.identify(user.userId.S, data);



      setTimeout(() => {
        setLoadState(false)
      }, 2000);
    }
  }, []); // Runs only once when the component mounts


  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div>
      <ChangeOrgModal open={openChangeOrg} setOpen={setOpenChangeOrg} user={user} changeOrganization={changeOrganization}
        orgs={orgs}
      />
      <Sidebar
        open={openSidebar}
        setOpen={setOpenSidebar}
        orgs={orgs}
      />
      {loadState ? (
        <div
          className="bg-white"
          style={{
            width: "100vw",
            height: "100vh",
            backdropFilter: "blur(10px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box>
            <div className="flex items-center text-black text-[15px] font-semibold">
              <div style={{ display: "flex", gap: "0.5rem", marginRight: '10px' }}>
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
              </div>
              <style jsx>{`
      .dot {
        width: 12px;
        height: 12px;
        background-color:rgb(74, 69, 234);  /* Starting color */
        border-radius: 50%;
        animation: bounce 1.5s infinite, colorChange 1.5s infinite;
      }
      .dot:nth-child(2) {
        animation-delay: 0.2s;
      }
      .dot:nth-child(3) {
        animation-delay: 0.4s;
      }
      @keyframes bounce {
        0%, 80%, 100% {
          transform: scale(0);
        }
        40% {
          transform: scale(1);
        }
      }
      @keyframes colorChange {
        0%, 100% {
          background-color: #605BFF;  /* Color at the start and end */
        }
        50% {
          background-color:rgb(255, 91, 91);  /* Color at the middle of the animation */
        }
      }
    `}</style>
              Twilanswer Loading
            </div>
          </Box>

        </div>
      ) : (
        <

          >


          <div className=" flex items-center lg:justify-between px-4 lg:hidden bg-white 
      lg:bg-transparent pb-4 pt-4 lg:pt-0 lg:pb-0 rounded-br-[20px] rounded-bl-[20px] lg:rounded-br-[20px] lg:rounded-bl-[20px] 
      ">
            <MenuIcon
              onClick={() => {
                setOpenSidebar(!openSidebar);
              }}
              sx={{
                color: { lg: 'black', xs: '#FFCC00' }
              }}
            />

            <div className="text-[20px] font-normal  text-center mx-auto flex items-center space-x-2  ">
              <img src='/icons/login_img.png' className="w-[30px] hidden" />
              <img src='/icons/logo_twil.jpeg' className="w-[170px] h-[70px] object-cover" /></div>
          </div>
          <div className="grid grid-cols-12">
            <div className="col-span-2 w-[220px]   flex-col min-h-[100vh] h-full hidden lg:flex ">
              <div className="bg-white relative  min-h-[100vh] h-full ">

                <div className="text-[20px] px-6 font-normal  text-center mb-0"><img src='/icons/logo_twil.jpeg' className="w-[140px] object-cover " /></div>
                <div className="text-[16px] pr-6 space-y-3  flex-1">
                  {location.pathname === '/dashboard' || location.pathname.startsWith('/dashboard/call-details') ? (
                    <div
                      onClick={() => {
                        navigate('/dashboard')
                      }}
                      className="cursor-pointer flex items-center text-[#605CFF] bg-gradient-to-r from-[#EBEBFC] to-[#fff] py-2 px-3">
                      {" "}
                      <img
                        src="/icons/dash-active.png"
                        className="w-[20px] mr-2"
                      />{" "}
                      Dashboard{" "}
                    </div>
                  ) : (
                    <div
                      className="cursor-pointer flex items-center py-2 px-3 text-[#7f7f92]"
                      onClick={() => {
                        navigate('/dashboard')
                      }}
                    >
                      {" "}
                      <img
                        src="/icons/dash-inactive.png"
                        className="w-[20px] mr-2"
                      />{" "}
                      Dashboard{" "}
                    </div>
                  )}

                  {location.pathname.startsWith('/dashboard/call-routings') || location.pathname.startsWith('/dashboard/call-route')
                    || location.pathname.startsWith('/dashboard/create-route') ? (
                    <div
                      onClick={() => {
                        navigate('/dashboard/call-routings')
                      }}
                      className="cursor-pointer flex items-center text-[#605CFF] bg-gradient-to-r from-[#EBEBFC] to-[#fff] py-2 px-3">
                      {" "}
                      <img
                        src="/icons/call-active.png"
                        className="w-[20px] mr-2"
                      />{" "}
                      Call Routing{" "}
                    </div>
                  ) : (
                    <div
                      className="cursor-pointer flex items-center py-2 px-3 text-[#7f7f92]"
                      onClick={() => {
                        navigate('/dashboard/call-routings')
                      }}
                    >
                      {" "}
                      <img
                        src="/icons/call-inactive.png"
                        className="w-[20px] mr-2"
                      />{" "}
                      Call Routing{" "}
                    </div>
                  )}

                  {location.pathname.startsWith('/dashboard/dialer') ? (
                    <div
                      onClick={() => {
                        navigate('/dashboard/dialer')
                      }}
                      className="cursor-pointer flex items-center text-[#605CFF] bg-gradient-to-r from-[#EBEBFC] to-[#fff] py-2 px-3">
                      {" "}
                      <img
                        src="/icons/dailer-active.png"
                        className="w-[20px] mr-2"
                      />{" "}
                      Dialer{" "}
                    </div>
                  ) : (
                    <div
                      className="cursor-pointer flex items-center py-2 px-3 text-[#7f7f92]"
                      onClick={() => {
                        navigate('/dashboard/dialer')
                      }}
                    >
                      {" "}
                      <img
                        src="/icons/dailer-inactive.png"
                        className="w-[20px] mr-2"
                      />{" "}
                      Dialer{" "}
                    </div>
                  )}

                  {location.pathname.startsWith('/dashboard/channels') ? (
                    <div
                      onClick={() => {
                        navigate('/dashboard/channels')
                      }}
                      className="cursor-pointer flex items-center text-[#605CFF] bg-gradient-to-r from-[#EBEBFC] to-[#fff] py-2 px-3">
                      {" "}
                      <img
                        src="/icons/notification-active.png"
                        className="w-[20px] mr-2"
                      />{" "}
                      Channels{" "}
                    </div>
                  ) : (
                    <div
                      className="cursor-pointer flex items-center py-2 px-3 text-[#7f7f92]"
                      onClick={() => {
                        navigate('/dashboard/channels')
                      }}
                    >
                      {" "}
                      <img
                        src="/icons/notification-inactive.png"
                        className="w-[20px] mr-2"
                      />{" "}
                      Channels{" "}
                    </div>
                  )}

                  {location.pathname.startsWith('/dashboard/recordings') ? (
                    <div
                      onClick={() => {
                        navigate('/dashboard/recordings')
                      }}
                      className=" cursor-pointer flex items-center text-[#605CFF] bg-gradient-to-r from-[#EBEBFC] to-[#fff] py-2 px-3">
                      {" "}
                      <img
                        src="/icons/microphone-active.png"
                        className="w-[20px] mr-2"
                      />{" "}
                      Recordings{" "}
                    </div>
                  ) : (
                    <div
                      className="cursor-pointer flex items-center py-2 px-3 text-[#7f7f92]"
                      onClick={() => {
                        navigate('/dashboard/recordings')
                      }}
                    >
                      {" "}
                      <img
                        src="/icons/microphone-inactive.png"
                        className="w-[20px] mr-2"
                      />{" "}
                      Recordings{" "}
                    </div>
                  )}

                  {location.pathname.startsWith('/dashboard/settings') ? (
                    <div
                      onClick={() => {
                        navigate('/dashboard/settings')
                      }}
                      className="cursor-pointer flex items-center text-[#605CFF] bg-gradient-to-r from-[#EBEBFC] to-[#fff] py-2 px-3">
                      {" "}
                      <img
                        src="/icons/settings-active.png"
                        className="w-[20px] mr-2"
                      />{" "}
                      Settings{" "}
                    </div>
                  ) : (
                    <div
                      className="cursor-pointer flex items-center py-2 px-3 text-[#7f7f92]"
                      onClick={() => {
                        navigate('/dashboard/settings')
                      }}
                    >
                      {" "}
                      <img
                        src="/icons/settings-inactive.png"
                        className="w-[20px] mr-2"
                      />{" "}
                      Settings{" "}
                    </div>
                  )}
                </div>
                {err_msg && (
                  <div className="text-center text-red-500 lg:text-[13px] text-[12px] mt-2  font-semibold ">
                    <ErrorOutline sx={{ fontSize: "" }} /> {err_msg}
                  </div>
                )}


                {/* <div className="mt-4">
                  {loader ? (
                    <CircularProgress size={"1.3rem"} sx={{ color: "blue" }} />
                  ) : (
                    <Select
                      IconComponent={KeyboardArrowDown}
                      fullWidth
                      value={
                        user?.relatedOrgs.L.filter(
                          (e) =>
                            e?.M.org_id.S ===
                            JSON.parse(localStorage.getItem("organization")).orgId.S
                        )[0]?.M.org_id.S
                      }
                      onChange={(f) => {
                        changeOrganization(f.target.value);
                      }}
                      className="mb-2 bg-[#F7F7F8]"
                      sx={{
                        fontSize: "13px",
                        padding: "2px 8px", // Adjust padding here
                        "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                        "& .MuiSelect-select": {
                          padding: "2px 8px", // Adjust padding for the text inside Select

                        },
                      }}
                    >
                      {user?.relatedOrgs.L.map((item, index) => {
                        return (
                          <MenuItem key={index} value={item?.M.org_id.S}>{orgs?.find((e) => e.orgId.S === item?.M.org_id.S)?.organization_name.S}</MenuItem>
                        );
                      })}
                    </Select>
                  )}
 
                </div> */}

                <div className="px-3  left-[10%]   absolute w-[80%] bottom-4 mt-auto bg-[#F7F7F8] py-1 rounded-lg">
                  <div className=" text-[14px]  font-semibold">
                    {
                        JSON.parse(localStorage.getItem("organization"))?.organization_name
                        .S.length > 17 ?
                      JSON.parse(localStorage.getItem("organization"))?.organization_name
                        .S.slice(0,17)+"..." : 
                        JSON.parse(localStorage.getItem("organization"))?.organization_name
                        .S
                    }{" "}
                    {/* <img src="/icons/Logout.png" className="w-[20px] ml-2 cursor-pointer" 
            onClick={()=> {
              localStorage.clear('user')
              localStorage.clear('organization')
              navigate('/login')
            }}
            />{" "} */}
                  </div>

                  <div className='text-[13px] text-black flex items-center justify-between'>
                    <div>
                      {JSON.parse(localStorage.getItem("user"))?.email
                        .S}
                    </div>

                    <KeyboardArrowRight
                    id="menu-button"
                    aria-controls={open ? "menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                    sx={{ fontSize: "20px", cursor:'pointer' }} />

<Menu
        id="menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "menu-button",
        }}
      >
         {user?.relatedOrgs.L.map((item, index) => {
                        return (
                          <MenuItem key={index} value={item?.M.org_id.S}
                          onClick={()=> {
                            changeOrganization(item?.M.org_id.S)
                          }}
                          sx={{
                            "& .MuiPaper-root": {
                              padding: 0, // Remove padding around the menu
                              margin: 0, // Ensure no margin
                            },
                            "& .MuiMenu-list": {
                              padding: 0, // Remove padding inside the menu list
                              margin:0
                            },
                          }}
                          >
                            <div className='text-[14px]  '>
                             <Radio
                             
                             checked={
                                  item.M.org_id.S ===
                                  JSON.parse(localStorage.getItem("organization")).orgId.S
                               ? true : false 
                             }
                             sx={{
                              "& .MuiSvgIcon-root": {
                                fontSize: 16, // Size of the radio icon
                                color: "#605BFF", // Default color for unchecked radio
                              },
                              "&.Mui-checked .MuiSvgIcon-root": {
                                color: "#605BFF", // Color when radio is checked
                              },
                            }}
                                />
                            {orgs?.find((e) => e.orgId.S === item?.M.org_id.S)?.organization_name.S}
                            </div>
                          </MenuItem>
                        );
                      })}
                      <MenuItem onClick={
                                      ()=>{
                                       handleClose()
                                      }
                                    } sx={{ bgcolor:'white', color:'black', fontWeight:'500'}} >
                                    <a href='mailto:hello@twilanswer.com' className="text-[14px] flex justify-center w-full" >  Contact Support</a>
                                    </MenuItem>
                      
        <MenuItem onClick={
          ()=>{
            navigate('/login')
            localStorage.clear()
          }
        } sx={{ bgcolor:'white', color:'red', fontWeight:'500'}} >
        <div className="text-[14px] flex items-center justify-center w-full" > <Logout sx={{ fontSize:'14px', mr:'2px'}} /> Log out</div>
        </MenuItem>
      </Menu>
                  </div>
                </div>
              </div>

            </div>
            <div className="lg:col-span-10 col-span-12 pb-2 ">
              <Routes>
                <Route path="/front" element={<FrontPluginDefault />} />
                <Route path="/" element={<Home />} />
                <Route path="/call-details/:call_id" element={<CallDetails conversation={conversation} />} />
                <Route path="/call-routings" element={<CallRoutings />} />
                <Route path="/call-route/:route_id" element={<CallRoute navigate={navigate} />} />
                <Route path="/create-route" element={<CallRoute navigate={navigate} />} />
                <Route path="/dialer" element={<Dailer />} />
                <Route path="/channels" element={<Channels />} />
                <Route path="/recordings" element={<Recordings />} />
                <Route path="/settings/*" element={<Settings />} />
              </Routes>
            </div>
          </div>


        </>
      )}


    </div>
  );
};

export default Dashboard;
